export const oneTimeParamPrefix = ['o_p_']

export const dohBoParamPrefix = ['sec_d_']
